export class SupportIntercomConstants {
  static truncateLimit = 99;
}
